import { render } from "./MovieModal.vue?vue&type=template&id=1392f1b3&scoped=true"
import script from "./MovieModal.vue?vue&type=script&lang=js"
export * from "./MovieModal.vue?vue&type=script&lang=js"

import "./MovieModal.vue?vue&type=style&index=0&id=1392f1b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1392f1b3"]])

export default __exports__